export default "__VITE_ASSET__kMySgmPS__"